import { IconType } from 'react-icons';
import { ReportingLoaderBaseConfig } from '../../../base';
import { TemplateItemAggregate } from '../item';
import { TemplateSelectLoader } from './templateSelectInterface';

export function createTemplateSelectLoader(
    config: ReportingLoaderBaseConfig & {
        items: TemplateItemAggregate[];
    }
): TemplateSelectLoader {
    return {
        useLoad(context, props) {
            return {
                items: config.items,
            };
        },
    };
}
